<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<m-search-item label="类型代码">
					<c-input name="type_code" maxlength="20"></c-input>
				</m-search-item>
				<m-search-item label="类型名称">
					<c-input name="type_name" maxlength="20"></c-input>
				</m-search-item>
			</m-search>

			<m-operate>
				<c-button color="main" v-if="auth('b_dic_type_edit')" prepend-icon="tf-add" @click="$refs.dicTypeEdit.open()">添加类型</c-button>
			</m-operate>

			<c-table ref="list" height="grow" :paging="true">
        <!--<c-table-column type="selector" width="32"></c-table-column>-->
				<c-table-column
					label="类型代码"
					name="type_code"
					width="150"
					fixed="left"
				>
				</c-table-column>

				<c-table-column
					label="类型名称"
					name="type_name"
					width="150"
					fixed="left"
				>
				</c-table-column>

        <c-table-column
            label="备注"
            name="remark"
            width="150"
        >
          <template #default="{data}">
            <span v-if="data.remark">{{data.remark}}</span>
            <span v-else>-</span>
          </template>
        </c-table-column>

				<c-table-column
					label="添加人"
					name="create_user_name"
					width="80"
				>
				</c-table-column>

				<c-table-column
					label="添加时间"
					name="create_date"
					width="130"
				>
				</c-table-column>

				<c-table-column
					type="button"
					label="操作"
					width="145"
					button-limit="6"
				>
					<template #default="{data}">
            <c-table-button v-if="auth('b_dic_type_edit')" icon="tf-edit" @click="$refs.dicTypeEdit.open(data)">编辑</c-table-button>
						<c-table-button v-if="auth('b_dic_type_edit')" icon="tf-trash" color="red" @click="removeDicType(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
			<!--添加/编辑分类信息弹窗-->
			<dic-type-edit ref="dicTypeEdit" @resolve="$refs.list.update()"></dic-type-edit>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import dicTypeEdit from "@/pages/system/dic_type_edit.vue";

	export default {
		components: {
      dicTypeEdit,
		},
		computed: {
      // 获取dictName选项数据
      ...mapState(['disableEnableDic'])
		},

		props: {
			type: String
		},

		data() {
			return {
			}
		},

		mounted() {
			this.searchHandle();
		},

		methods: {
			/********搜索************/
			searchHandle(data){
				if (!data){
					data = {};
				}
				this.$refs.list.load({
					url: '/dic/type/list',
					data
				});
			},

			/******删除分类***********/
			removeDicType(data){
				this.$confirm({
					message:'确认删除字典类型【'+data.type_name+'】？删除后不可恢复',  // 提示内容,
					// buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/dic/del/type',
							data: {
                dic_type_id:data.id
              },
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								this.$refs.list.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>